export default "__VITE_ASSET__CAWLG6sr__"